import { Button } from "flowbite-react";
import LienFormFields from "./LienFormFields";

export default function LienEditorCard({
  deleting,
  form,
  onChange,
  onDelete,
  onSave,
  saving,
}) {
  return (
    <div className="rounded-lg border border-gray-200 dark:border-gray-800 p-4 bg-white dark:bg-gray-900 space-y-3">
      <LienFormFields form={form} onChange={onChange} />

      <div className="flex justify-end gap-2">
        <Button color="gray" onClick={onSave} disabled={saving}>
          {saving ? "Salvando..." : "Salvar"}
        </Button>

        <Button color="failure" onClick={onDelete} disabled={deleting}>
          {deleting ? "Excluindo..." : "Excluir"}
        </Button>
      </div>
    </div>
  );
}
